import { createSlice } from '@reduxjs/toolkit';

interface BranchState {
	value: {
		restaurants: Array<{
			email: string;
			customer_id: string;
			lastname: string;
			firstname: string;
			telephone: string;
			profile_picture: string;
			address: string;
			company_name: string;
			userId: string;
		}>;
		default: {
			email: string;
			customer_id: string;
			lastname: string;
			firstname: string;
			telephone: string;
			profile_picture: string;
			address: string;
			company_name: string;
			userId: string;
		} | null;
		selectedBranch: null | any;
	};
	allBranch: [];
	pageNumber: number;
}

const initialState: BranchState = {
	value: {
		restaurants: [],
		default: null,
		selectedBranch: null,
	},
	allBranch: [],
	pageNumber: 1,
};

export const branchSlice = createSlice({
	name: 'restaurants',
	initialState,
	reducers: {
		setRestaurants: (state, restaurants) => {
			state.value.restaurants = restaurants.payload;
		},
		setDefaultRestaurant: (state, restaurants) => {
			state.value.default = restaurants.payload;
		},
		setSelectedBranch: (state, restaurants) => {
			state.value.selectedBranch = restaurants.payload;
		},
		setBranches: (state, action) => {
			state.allBranch = action.payload;
		},
		setPageNumber: (state, action) => {
			state.pageNumber = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setRestaurants, setDefaultRestaurant, setBranches, setPageNumber } =
	branchSlice.actions;

export default branchSlice.reducer;
